import { createFileRoute } from "@tanstack/react-router"
import { meta } from "@/content"
import { GetStartedPage } from "@/app"

export const Route = createFileRoute("/(public)/auth/")({
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Sign Up" }) }),
})

function RouteComponent() {
  return <GetStartedPage />
}
